import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function GalleryScrollTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => setVisible(window.scrollY > 500);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  if (!visible) return null;
  return (
    <button className="gallery-scroll-top" type="button" aria-label="Back to top"
      onClick={() => {
        window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
        document.querySelector(".site-header__links a")?.focus({ preventScroll: true });
      }}>
      <FaArrowUp aria-hidden="true" />
    </button>
  );
}
